module.exports = __webpack_public_path__ + "img/icon-source.d8d5353d.svg";